<script>
  import AtomSpan from "@/components/atoms/AtomSpan.vue";
  export default {
    components: {
      AtomSpan,
    },
    props: {
      icon: {
        type: Object,
      },
      defaultText: {
        type: String,
        default: "Text",
      },
    },
  };
</script>

<template>
  <div class="userAvatar">
    <Avatar class="userAvatar__image" :user="icon" />
    <AtomSpan class="userAvatar__userCheck" :defaultText="defaultText" />
  </div>
</template>

<style lang="scss">
  .userAvatar {
    @include Flex(row, center, center);
    gap: 8px;
    border-radius: 50%;
    &__image {
      width: 25px;
      height: 25px;
      border: 1.5px solid $primary;
    }
    &__userCheck {
      text-transform: capitalize;
    }
  }
</style>
